import Swiper from "swiper";
import { Thumbs, Navigation, EffectFade, Pagination } from "swiper/modules";

function sliderProduct() {
  var swiper = new Swiper(".product__slider .product__slider-thumbs .swiper", {
    modules: [ Navigation ],
    spaceBetween: 10,
    allowTouchMove: false,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      prevEl: '.product__slider .swiper-button-prev',
      nextEl: '.product__slider .swiper-button-next',
    },
  });
  new Swiper(".product__slider .product__slider-main .swiper", {
    modules: [ Thumbs, EffectFade, Navigation, Pagination ],
    effect: 'fade',
    allowTouchMove: true,
    fadeEffect: {
      crossFade: true
    },
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
    navigation: {
      prevEl: '.product__slider .swiper-button-prev',
      nextEl: '.product__slider .swiper-button-next',
    },
    breakpoints: {
      1226: {
        allowTouchMove: false,
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });
}
sliderProduct();